// core
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

// campfire
import { ContentService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class ExtraResolver {

  constructor(private contentService: ContentService) { }
  
    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<any>|Promise<any>|any {
  
      return this.contentService.getById(route.params.slug)
        .then((response: any) => {
          return response;
        });
    }
}
